module.exports = __webpack_public_path__ + "img/logo-leafly.24b68844.png";